import { useState, useEffect, useContext } from 'react';
import { UserContext, AppContext, ModalContext, ThemeContext } from '../../contexts';

import { MainLayOut } from "../../layouts";
import { Circle, Loader, SimpleLoader } from "../../assets";

import PublicationRow from './components/pubrow';

import { useNavigateTo } from '../../hooks';

import { privateRoutes } from '../../routes';
import { getYearViewsAPI, getMonthViewsAPI, getWeekViewsAPI, getTodayViewsAPI, getMylastEditedAPI, updatePublicationAPI } from '../../services';
import { error_type } from '../../models';

import style from './dashboard.module.scss';



const Dashboard = () => {

    const {
        allPublications, setAllPublications, setIdEditPublication, setEditPublication,

        yearVisits, setYearVisits,
        monthVisits, setMonthVisits,
        // weekVisits, setWeekVisits,
        // last7Days, setLast7Days,
        // last30Days, setLast30Days,
        todayVisits, setTodayVisits,

        monthLoading, setMonthLoading,
        yearLoading, setYearLoading,
        // weekLoading, setWeekLoading,
        // last7Loading, setLast7Loading,
        // last30Loading, setLast30Loading,
        todayLoading, setTodayLoading,
    } = useContext(AppContext);

    const { user, token, deleteUser, deleteToken } = useContext(UserContext);
    const { activateNotification } = useContext(ModalContext);
    const { theme } = useContext(ThemeContext);

    const [ goto ] = useNavigateTo()

    const [ isLoading, setIsLoading ] = useState(false);

    const handleEditPublicationById = (id) => {
        setIdEditPublication(id);
        setEditPublication({});
        goto(privateRoutes.EDITPUBLICATION);
    };

    const handlePlayPausePublication = (id, status) => {
        const data = { status };
        activateNotification('', 'time', false);
        updatePublicationAPI(data, id, token)
        .then( res => {
            if (res.error) {
                if (res.errortype === error_type.AUTH) {
                    activateNotification(`${res.message}`, 'error', true, 4000);
                    deleteUser(); deleteToken();
                    return;
                }
                activateNotification(`${res.message}`, 'error', true, 4000);
                return;
            }
            activateNotification(`${res.message}`, 'ok', true, 4000);
            const updatedState = allPublications.map( pub => {
                if ( pub.id === id ) {
                    return {...pub, status }
                };
                return pub;
            });
            setAllPublications(updatedState);
            return;
        })
    };

    const handleGetLastEdited = () => {
        getMylastEditedAPI(token)
        .then( res => {
            if (res.error) {
                if (res.errortype === error_type.AUTH) {
                    deleteUser(), deleteToken();
                    setIsLoading(false);
                    activateNotification(`${res.message}`, 'error', true, 5000);
                    return;
                }
                activateNotification(`${res.message}`, 'error', true, 5000);
                setIsLoading(false);
                return;
            };
            setAllPublications(res.data);
            setIsLoading(false);
            return;
        })
    };

 
    useEffect( () => {
        const abortController = new AbortController();
        const signal = abortController.signal;
        handleGetLastEdited();
  
        
        if ( yearVisits <= 0 ){
            setYearLoading(true);
            getYearViewsAPI(token, signal)
            .then( res => {
                if (res.error) {
                    if (res.errortype === error_type.AUTH) {
                        deleteUser(); deleteToken();
                        activateNotification(`${res.message}`, 'error', true, 4000);
                        setYearLoading(false);
                        return;
                    }
                    activateNotification(`${res.message}`, 'error', true, 4000);
                    setYearLoading(false);
                    return;
                };
                setYearVisits(res.data);
                setYearLoading(false);
                return;
            });
        };

        if ( monthVisits <= 0 ) {
            setMonthLoading(true);
            getMonthViewsAPI(token, signal)
            .then( res => {
                if (res.error) {
                    if (res.errortype === error_type.AUTH) {
                        deleteUser(); deleteToken();
                        activateNotification(`${res.message}`, 'error', true, 4000);
                        setMonthLoading(false);
                        return;
                    }
                    activateNotification(`${res.message}`, 'error', true, 4000);
                    setMonthLoading(false);
                    return;
                };
                setMonthVisits(res.data);
                setMonthLoading(false);
                return;
            });
        };
        // if (last30Days <= 0 || last7Days <= 0 || weekVisits <= 0 ) {
        //     setWeekLoading(true);
        //     setLast7Loading(true);
        //     setLast30Loading(true);
        //     getWeekViewsAPI(token)
        //     .then( res => {
        //         if (res.error) {
        //             if (res.errortype === error_type.AUTH) {
        //                 deleteUser(); deleteToken();
        //                 activateNotification(`${res.message}`, 'error', true, 4000);
        //                 setWeekLoading(false);
        //                 setLast30Loading(false);
        //                 setLast7Loading(false);
        //                 return;
        //             }
        //             activateNotification(`${res.message}`, 'error', true, 4000);
        //             setWeekLoading(false);
        //             setLast30Loading(false);
        //             setLast7Loading(false);
        //             return;
        //         };
        //         setWeekVisits(res.data.lastWeek);
        //         setLast7Days(res.data.lastSeven);
        //         setLast30Days(res.data.lastThirty);
        //         setWeekLoading(false);
        //         setLast30Loading(false);
        //         setLast7Loading(false);
        //         return;
        //     });
        // }

        if (todayVisits <= 0) {
            setTodayLoading(true);
            getTodayViewsAPI(token, signal)
            .then( res => {
                if (res.error) {
                    if (res.errortype === error_type.AUTH) {
                        deleteUser(); deleteToken();
                        activateNotification(`${res.message}`, 'error', true, 4000);
                        setTodayLoading(false);
                        return;
                    }
                    activateNotification(`${res.message}`, 'error', true, 4000);
                    setTodayLoading(false);
                    return;
                };
                setTodayVisits(res.data);
                setTodayLoading(false);
                return;
            });
        };

        return () => {
            abortController.abort();
        }
    },[]);


    return (

        <MainLayOut>
            {
                isLoading
                ?
                <Loader background={theme.alphaBackground}/>
                :
                <>
                    <div className={style.title_container}>
                    <p className={style.main_title} style={{color:`${theme.text}`}}>Dashboard</p>
                    </div>

                    <div className={style.blocks_container}>
                        <p className={style.light_subtitle} style={{color:`${theme.text}`}}>Estadísticas generales</p>
                    </div>

                    <div className={style.blocks_container}>
                        {/* ********** AÑO Y MES ************** */}
                        
                   

                        <div className={style.block} style={{background:`${theme.background}`}}>

                            {
                                yearLoading
                                ?
                                <SimpleLoader />
                                :
                                <div className={style.dual_data}>
                                    <div className={style.data_circle}>
                                        <p className={`${style.data} ${style.bold_text}`} style={{color:`${theme.text}`}}>
                                            100%
                                        </p>
                                        <div className={style.circle}>
                                            <Circle width='90px' heigth='90px' strokeWidth={2.5} strokeColor={theme.strokeColor01} value='100'/>
                                        </div>
                                    </div>
                                    <p className={style.small_light_text} style={{color:`${theme.text}`}}>
                                        Visitas del año:
                                        <span className={style.mid_bold_text}> {yearVisits}</span>
                                    </p>
                                </div>
                            }
                        </div>

                        <div className={style.block} style={{background:`${theme.background}`}}>
                            {
                                monthLoading
                                ?
                                <SimpleLoader />
                                :
                                <div className={style.dual_data}>
                                    <div className={style.data_circle}>
                                        <p className={`${style.data} ${style.bold_text}`} style={{color:`${theme.text}`}}>
                                            {
                                                yearVisits > 0 && monthVisits > 0
                                                ?
                                                (monthVisits * 100 / yearVisits).toFixed(1)
                                                :
                                                '-'
                                            }
                                            %
                                        </p>
                                        <div className={style.circle}>
                                            <Circle width='90px' heigth='90px' strokeWidth={2.5} strokeColor={theme.strokeColor02} value={Math.round(monthVisits * 100 / yearVisits)}/>
                                        </div>
                                    </div>
                                    <p className={style.small_light_text} style={{color:`${theme.text}`}}>
                                        Visitas mensuales:
                                        <span className={style.mid_bold_text}> {monthVisits}</span>
                                    </p>
                                </div>
                            }
                        </div>
                      


                        <div className={style.block} style={{background:`${theme.background}`}}>
                            {
                                todayLoading
                                ?
                                <SimpleLoader />
                                :
                                <div className={style.dual_data}>
                                    <div className={style.data_circle}>
                                        <p className={`${style.data} ${style.bold_text}`} style={{color:`${theme.text}`}}>
                                            {
                                                monthVisits > 0 && todayVisits > 0
                                                ?
                                                (todayVisits * 100 / monthVisits).toFixed(1)
                                                :
                                                "-"
                                            }
                                            %
                                        </p>
                                        <div className={style.circle}>
                                            <Circle width='90px' heigth='90px' strokeWidth={2.5} strokeColor={theme.strokeColor04} value={Math.floor(todayVisits * 100 / monthVisits)}/>
                                        </div>
                                    </div>
                                    <p className={style.small_light_text} style={{color:`${theme.text}`}}>
                                        Visitas diarias:&emsp;
                                        <span className={style.mid_bold_text}>{todayVisits}</span>
                                    </p>
                                </div>
                            }

                        </div>

                    </div>



                    <div className={style.blocks_container}>
                        <p className={style.light_subtitle} style={{color:`${theme.text}`}}>Tu última actividad</p>
                    </div>
                    
                    <div className={style.blocks_container}>

                        <div className={style.block} style={{display:'flex',flexDirection:'column', justifyContent:'flex-start', alignItems:'flex-start',background:`${theme.background}`}}>
                            <p className={style.big_bold_text} style={{padding: '22px 0',color:`${theme.text}`}}>
                                Últimas ediciones:
                            </p>
                            {
                                allPublications.map( (publication, i) => {
                                    return (
                                        <PublicationRow key={publication.id} i={i} publication={publication} theme={theme} edithandler={handleEditPublicationById} playPauseHandler={handlePlayPausePublication} user={user} />
                                    )
                                })
                            }
                        </div>
                        
                    </div>
                </>
            }

        </MainLayOut>
    )
};

export default Dashboard;
